import React from 'react';
import styled from 'styled-components';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';

import { useCurrentTracklog } from 'ff/debrief/hooks';
import { useDebriefModal } from 'ff/debrief/modalManager';
import { durationSecondsToString, formatGroundSpeed } from 'ff/debrief/utils';
import DebriefDialogTitle from 'ff/debrief/components/modals/DebriefDialogTitle';
import InfoDivider from 'ff/debrief/components/infoTable/InfoDivider';
import InfoRow from 'ff/debrief/components/infoTable/InfoRow';
import NotesRow from 'ff/debrief/components/infoTable/NotesRow';

const OtherInfoModal = () => {
    const { isOpen, close } = useDebriefModal('OtherInfo');

    const { tracklog: tl, metadata, trimmedValues } = useCurrentTracklog();

    const handleClose = () => {
        close();
    };

    if (!tl || !trimmedValues) return null;
    return (
        <Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
            <DebriefDialogTitle onClose={handleClose}>
                Details
            </DebriefDialogTitle>
            <DialogContent sx={{ padding: '16px' }}>
                <List>
                    <InfoDivider label="Summary" />
                    <InfoRow label="Track Log Name" border>
                        {tl.name}
                    </InfoRow>
                    <InfoRow label="Pilot Name" border>
                        {tl.pilotName}
                    </InfoRow>
                    <InfoRow label="Initial GPS Source" border>
                        {tl.initialGpsSource}
                    </InfoRow>
                    <InfoRow label="Recorded On">{tl.recordingDevice}</InfoRow>
                    <InfoDivider label="Metrics" />
                    <InfoRow label="Flight Time" border>
                        {durationSecondsToString(
                            trimmedValues.actualFlightTime
                        )}
                    </InfoRow>
                    <InfoRow label="Avg Ground Speed" border>
                        {formatGroundSpeed(trimmedValues?.avgGndspd)}
                    </InfoRow>
                    <InfoRow
                        label="Minimum g Load"
                        showSentryMsg={!trimmedValues?.minimumG}
                        border
                    >
                        {trimmedValues?.minimumG
                            ? trimmedValues?.minimumG.toFixed(2)
                            : '-'}
                    </InfoRow>
                    <InfoRow
                        label="Maximum g Load"
                        showSentryMsg={!trimmedValues?.maximumG}
                    >
                        {trimmedValues?.maximumG
                            ? trimmedValues?.maximumG.toFixed(2)
                            : '-'}
                    </InfoRow>
                    <InfoDivider label="Notes" />
                    <NotesRow>{metadata?.userRemarks?.trim() || '-'}</NotesRow>
                </List>
            </DialogContent>
        </Dialog>
    );
};

const List = styled.ol`
    list-style: none;
    margin: 0;
    padding: 0;
`;

export default OtherInfoModal;
